module.exports = __webpack_public_path__ + "static/media/exam.18e8b341.png";